export const visit = (vm, at) => {
vm(require("foundations-components/lang/fi.lyaml"));
at({ "fi": { "placeholder": "paikkamerkki" } });
};